// extracted by mini-css-extract-plugin
export default {"root":"AdminList_root__9WOjM"};